import { SetStateAction, useEffect } from "react";

interface Props {
  render: any;
  elementClassName: string;
  setView: (val: SetStateAction<boolean>) => void;
}

export default function useInterSectionObserver({
  elementClassName,
  render,
  setView,
}: Props) {
  function callback(entries: IntersectionObserverEntry[]) {
    const intersectionItem = entries[0];

    if (
      intersectionItem.target.classList.contains("lastProduct") &&
      intersectionItem.isIntersecting
    ) {
      setView(intersectionItem.isIntersecting);
    } else {
      setView(false);
    }
  }

  useEffect(() => {
    const observer = new IntersectionObserver(callback);

    const element = document.querySelectorAll(elementClassName);
    element.forEach((item, index) => {
      if (index + 1 > element.length - 4) {
        item.classList.add("lastProduct");
      }

      observer.observe(item);
    });
  }, [render]);
}
